import { refreshAccessToken } from './manager';

const AUTH_TOKENS = '/auth/tokens';
const LOGIN = '/login';
const PASSWORD = '/password';
const SIGNUP = '/signup';
const UNLOCK = '/unlock';

// API endpoints that do not require an access token. The refreshInterceptor, responsible
// for refreshing access tokens, is unnecessary.
const EXEMPT_PATHS = new Set([AUTH_TOKENS, LOGIN, PASSWORD, SIGNUP, UNLOCK]);

// In the case of a 401 error, the refreshInterceptor intercepts the request, refreshes
// the access token, then replays the request.
export const createRefreshInterceptor = (client) => [
  (response) => response,
  async (error) => {
    const { config, response } = error;

    if (
      response?.status !== 401 ||
      !config ||
      config.isRetry ||
      EXEMPT_PATHS.has(config.url)
    ) {
      return Promise.reject(error);
    }

    let accessToken;
    config.isRetry = true;

    try {
      accessToken = await refreshAccessToken();
    } catch (refreshError) {
      return Promise.reject(error);
    }

    config.headers.Authorization = accessToken;

    return client(config);
  },
];

export default createRefreshInterceptor;
